import React, { Fragment, useState } from "react";

import { Link } from "react-router-dom";
import classnames from "classnames";
import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  Label,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Table,
} from "reactstrap";
import axios from "axios";
import { GetCookieData, GetCookieToken } from "../Cookie/GetCookie";
import { FetchAxiosFile, FetchAxiosGet, FetchAxiosPost } from "../../api/axios";
import { useEffect } from "react";
import Lottie from "react-lottie";
import LoadingData from "../TESTPage/LoadingData";
import UserSelector from "../../components/users/UsersSelector";
import { CheckSubAdmin } from "../Function/CheckSubAdmin";
import EvaluateFormHeader, { checkEvaluateScoreLevel, checkExpectLevel, EVALUATE_WEIGHT_NORMAL, getEvaluateWeight } from "./evaluateConfig";
import { createBehaviorRows, shouldUseOldBehaviorRows } from "./shared/behaviorTemplate";


const API_URL = process.env.REACT_APP_API_CORS;
function ViewEvaluate(props) {
  const {
    user_id,
    evaluate_salary_id,
    budget_year,
    round,
    approve_user_id,
    updateApprove,
    approve_user,
    evaluateLink,
    userInfo
  } = props;
  // ใบประเมินปี 2569 รอบ 1 และปีก่อนหน้า ใช้สมรรถนะชุดเก่า
  const useOldBehaviorRows = shouldUseOldBehaviorRows(budget_year, round);
  const [passedSteps, setPassedSteps] = useState([1]);
  const [activeTab, setactiveTab] = useState(1);
  const [loading, setLoading] = useState(false);

  const [fileUploads, setFileUploads] = useState(
    Array.from({ length: 5 }, () => null)
  );

  const [groups, setGroups] = useState([
    {
      indicator: "",
      scores: ["", "", "", "", ""],
      score: "",
      weight: "",
    },
    {
      indicator: "",
      scores: ["", "", "", "", ""],
      score: "",
      weight: "",
    },
    {
      indicator: "",
      scores: ["", "", "", "", ""],
      score: "",
      weight: "",
    },
    {
      indicator: "",
      scores: ["", "", "", "", ""],
      score: "",
      weight: "",
    },
    {
      indicator: "",
      scores: ["", "", "", "", ""],
      score: "",
      weight: "",
    },
  ]);

  const [formTwoData, setFormTwoData] = useState(() => createBehaviorRows(false, null, useOldBehaviorRows));

  const [formTheeData_1, setFormTheeData_1] = useState({
    label: "องค์ประกอบที่ 1 : ผลสัมฤทธิ์ของงาน",
    score: "",
    percentage: EVALUATE_WEIGHT_NORMAL.first,
    // no: 2,
  });

  const [formTheeData_2, setFormTheeData_2] = useState({
    label: "องค์ประกอบที่ 2 : พฤติกรรมการปฏิบัติราชการ(สมรรถนะ)",
    score: "",
    percentage: EVALUATE_WEIGHT_NORMAL.second,
    // no: 3,
  });

  const [formFourData, setFormFourData] = useState([
    { id: 1, topic: "", description: "" },
    { id: 2, topic: "", description: "" },
    { id: 3, topic: "", description: "" },
    { id: 4, topic: "", description: "" },
    { id: 5, topic: "", description: "" },
  ]);

  const [calculatedValues, setCalculatedValues] = useState([]);
  const [calculatedValuesForm2, setCalculatedValuesForm2] = useState([]);
  const [evaluateData, setEvaluateData] = useState([]);
  const [evaluateDataBehavior, setEvaluateDataBehavior] = useState([]);
  const [evaluateBehaviorLoaded, setEvaluateBehaviorLoaded] = useState(false);
  const [dataInfo, setDataInfo] = useState([]);
  const [approveInfo, setApproveInfo] = useState([]);
  const [updateApproveUser, setUpdateApproveUser] = useState([]);
  const [evaluateDataDevelopment, setEvaluateDataDevelopment] = useState([]);

  // น้ำหนักองค์ประกอบ: ปกติ 70/30 แต่ถ้า "ยังไม่ผ่านการทดลองงาน" (user_trial = 1) ใช้ 50/50
  useEffect(() => {
    const weight = getEvaluateWeight(dataInfo);
    setFormTheeData_1(prevData => ({ ...prevData, percentage: weight.first }));
    setFormTheeData_2(prevData => ({ ...prevData, percentage: weight.second }));
  }, [dataInfo?.user_trial]);


  const [approveUserFlow, setApproveUserFlow] = useState(null)
  const [flowLoading, setFlowLoading] = useState(false)

  const [evaluateSalaryApprove, setEvaluateSalaryApprove] = useState([])

  const token = GetCookieToken("userToken");


  useEffect(() => {
    fetchApproveUserFlow()
  }, []);

  const fetchApproveUserFlow = async () => {
    //evaluate_salary_id
    setFlowLoading(true)
    try {
      const url = `${API_URL}/api/evaluateSalaryFlow/datatable`;
      const params = new URLSearchParams({
        page: 1,
        size: 10,
        "order[0]": "step",
        "order[1]": "ASC",
        "filter[evaluate_salary_id][0]": evaluate_salary_id,
        "filter[status][0]": 1,
      });
      const config = { headers: { Authorization: `Bearer ${token}` }, params };
      const response = await axios.get(url, config);
      setApproveUserFlow(response.data.result)
    } catch (error) {
      console.error("Error fetching approve user flow:", error);
    } finally {
      fetchEvaluateSalaryApprove()
    }
  }

  const fetchEvaluateSalaryApprove = async () => {
    setFlowLoading(true)
    try {
      const url = `${API_URL}/api/evaluateSalaryApprove/datatable`;
      const params = new URLSearchParams({
        page: 1,
        size: 50,
        "order[0]": "evaluate_salary_approve_id",
        "order[1]": "DESC",
        "filter[evaluate_salary_id][0]": evaluate_salary_id,
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const approveResponse = (await axios.get(url, config)).data.result;

      const maxVersion = Math.max(...approveResponse.map(item => Number(item.version)));

      const latestVersionData = approveResponse.filter(
        item => Number(item.version) === maxVersion
      );
      setEvaluateSalaryApprove(latestVersionData)
    } catch (error) {
      console.error("Error fetching approve user flow:", error);
    } finally {
      setFlowLoading(false)
    }
  }

  const handleDevelopmentChange = (id, field, value) => {
    setFormFourData(prevData =>
      prevData.map(item =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };

  const toggleTab = tab => {
    if (activeTab !== tab) {
      var modifiedSteps = [...passedSteps, tab];
      if (tab >= 1 && tab <= 4) {
        setactiveTab(tab);
        setPassedSteps(modifiedSteps);
      }
    }
  };

  useEffect(() => {
    const calculatedValues = evaluateData.map(
      (group, index) => (group.weight * group.score) / 100
    );
    const sum = calculatedValues.reduce(
      (accumulator, currentValue) => accumulator + currentValue.toFixed(4) * 1,
      0
    );

    setCalculatedValues(sum);
    setFormTheeData_1(prevData => ({
      ...prevData,
      score: (sum * (100 / 5)).toFixed(4),
    }));
  }, [evaluateData]);

  useEffect(() => {
    const calculatedValues = formTwoData.map(
      (group, index) => (group.score * group.percentage) / 100
    );
    const sum = calculatedValues.reduce(
      (accumulator, currentValue) => accumulator + currentValue.toFixed(4) * 1,
      0
    );
    
    setCalculatedValuesForm2(sum);
    setFormTheeData_2(prevData => ({
      ...prevData,
      score: (sum * (100 / 5)).toFixed(4),
    }));
  }, [formTwoData]);

  let valScore =
    (Number(formTheeData_2.score) * Number(formTheeData_2.percentage)) / 100 +
    (Number(formTheeData_1.score) * Number(formTheeData_1.percentage)) / 100;

  useEffect(() => {
    const url = `${API_URL}/api/users/${user_id}`;
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(url, config)
      .then(response => {
        setDataInfo(response.data.result);
      })
      .catch(error => {
        console.error(error);
      });
  }, []);

  useEffect(() => {
    // if (approve_user_id !== null && approve_user_id !== undefined) {
    const url = `${API_URL}/api/users/${approve_user_id}`;
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(url, config)
      .then(response => {
        setApproveInfo(response.data.result);
      })
      .catch(error => {
        console.error(error);
      });
    // }
  }, []);

  const fetchEvaluateResult = async () => {
    const url = `${API_URL}/api/evaluateSalaryResult/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 1000,
      "order[0]": "evaluate_salary_result_id",
      "order[1]": "DESC",
      "filter[budget_year][0]": budget_year,
      "filter[round][0]": round,
      "filter[evaluate_salary_id][0]": evaluate_salary_id,
      "filter[user_id][0]": user_id,
      // "filter[step_active][0]": 1,
    });
    // if (Number(budget_year) >= 2568) {
    //   params.append("filter[step_active][0]", 1);
    // }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    };
    await axios
      .get(url, config)
      .then(response => {
        const result = response.data.result;
        let maxStep = -Infinity;
              
        for (const r of result) {
          if (r.step_active > maxStep) {
            maxStep = r.step_active;
          }
        }
        
        const newData = result.filter(r => r.step_active === maxStep);
        console.log(newData);
        
        setEvaluateData(newData);
      })
      .catch(error => console.error("Error:", error));
  };

  const fetchEvaluateBehavior = async () => {
    const url = `${API_URL}/api/evaluateSalaryBehavior/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 20,
      "order[0]": "evaluate_salary_behavior_id",
      "order[1]": "ASC",
      "filter[budget_year][0]": budget_year,
      "filter[round][0]": round,
      "filter[evaluate_salary_id][0]": evaluate_salary_id,
      "filter[user_id][0]": user_id,
      // "filter[step_active][0]": 1,
    });
    // if (Number(budget_year) >= 2568) {
    //   params.append("filter[step_active][0]", 1);
    // }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    };

    await axios
      .get(url, config)
      .then(response => {
        // เก็บผลดิบไว้ก่อนเฉยๆ ให้ useEffect ที่รอ dataInfo.user_category_id
        // (ด้านล่าง) เป็นคนสร้าง formTwoData ด้วยชุดแถวที่ถูกต้องตามสมรรถนะ
        // (BASE_ROWS หรือ EXPERT_ROWS) แล้ว merge คะแนนเดิมเข้าไป — ไม่ต้องเดา
        // จาก maxNo อีกต่อไป เพราะรู้ category ที่แน่ชัดอยู่แล้ว
        setEvaluateDataBehavior(response.data.result);
        setEvaluateBehaviorLoaded(true);
      })
      .catch(error => console.error("Error:", error));
  };

  // สร้าง/รวมข้อมูลตาราง "พฤติกรรมการปฏิบัติราชการ" ใหม่ ก็ต่อเมื่อรู้ user_category_id
  // แน่ชัดแล้ว (dataInfo โหลดเสร็จ) และคะแนนเดิมจาก API โหลดเสร็จแล้วด้วย (evaluateBehaviorLoaded)
  // เพื่อให้ได้ชุดแถว (BASE_ROWS/EXPERT_ROWS) ที่ถูกต้องตามสมรรถนะของ user คนนี้จริงๆ
  // ตรงกับที่หน้า Edit ใช้ (dataInfo.user_category_id) แทนการเดาจาก maxNo ของข้อมูลเดิม
  useEffect(() => {
    if (!evaluateBehaviorLoaded) return;

    const rebuiltFormTwoData = createBehaviorRows(false, dataInfo.user_category_id, useOldBehaviorRows).map(row => {
      const matched = evaluateDataBehavior.find(evalItem => evalItem.no === row.no);
      return {
        ...row,
        score: matched ? matched.score : "",
      };
    });

    setFormTwoData(rebuiltFormTwoData);
  }, [dataInfo?.user_category_id, evaluateBehaviorLoaded, evaluateDataBehavior]);

  const fetchEvaluateDevelopment = async () => {
    const url = `${API_URL}/api/evaluateSalaryDevelopment/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 10,
      "order[0]": "no",
      "order[1]": "ASC",
      "filter[budget_year][0]": budget_year,
      "filter[round][0]": round,
      "filter[evaluate_salary_id][0]": evaluate_salary_id,
      "filter[user_id][0]": user_id,
      // "filter[step_active][0]": 1,
    });
    // if (Number(budget_year) >= 2568) {
    //   params.append("filter[step_active][0]", 1);
    // }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    };
    await axios
      .get(url, config)
      .then(response => {
        setFormFourData(prevFormTwoData => {
          const updatedFormTwoData = prevFormTwoData.map(formItem => {
            const matchingEvaluateData = response.data.result.find(
              evalItem => evalItem.no === formItem.no
            );

            return {
              ...formItem,
              topic: matchingEvaluateData ? matchingEvaluateData.score : "",
            };
          });

          return updatedFormTwoData;
        });
        setEvaluateDataDevelopment(response.data.result);
      })
      .catch(error => console.error("Error:", error));
  };

  useEffect(() => {
    const letEffect = async () => {
      setLoading(true)
      await fetchEvaluateResult();
      await fetchEvaluateBehavior();
      await fetchEvaluateDevelopment();
      setTimeout(() => {
        setLoading(false)
      }, 2500);
    }
    letEffect()
  }, []);

  useEffect(() => {
    if (updateApprove !== null && updateApprove !== undefined) {
      const url = `${API_URL}/api/users/${updateApprove.approve_user_id}`;
      const config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${token}`,
        },
      };
      axios
        .get(url, config)
        .then(response => {
          setUpdateApproveUser(response.data.result);
        })
        .catch(error => {
          console.error(error);
        });
    }
  }, []);

  const handleAddUserFlow = () => {
    setApproveUserFlow(prev => {
      const userFlowSet = [...prev]
      const index = userFlowSet.findIndex(u => u.assessor === 1);
      const newUser = { approve_user: "", approve_user_position_name: "", cont_to: "" }
      if (index !== -1) {
        userFlowSet.splice(index, 0, newUser);
      } else {
        userFlowSet.push(newUser);
      }

      return userFlowSet
    });
  };

  const handleRemoveUserFlow = (index) => {
    setApproveUserFlow(prev => prev.filter((_, i) => i !== index));
  };

  const handleChangeUser = (index, value) => {
    setApproveUserFlow(prev => {
      const updated = prev.map((item, i) => {
        if (i === index) {
          return {
            ...item,
            approve_user_id: value.user_id,
            approve_user: value.user_name,
            approve_user_position_name: value.user_position_name,
            cont_to: value.cont_to
          };
        }
        return item;
      });

      const reIndexed = updated.map((item, i) => ({
        ...item,
        step: i + 1
      }));

      // console.log("value:", value, "updated:", reIndexed);

      return reIndexed;
    });
  };

  const handleEditFlow = async () => {
    setFlowLoading(true)
    try {
      const data = transformApproveFlow(approveUserFlow)
      const url = `${API_URL}/api/evaluateSalaryFlow/editFlow`;
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const response = await axios.post(url, data, config);
    } catch (error) {
      console.error("Error fetching approve user flow:", error);
    } finally {
      fetchApproveUserFlow()
      setFlowLoading(false)
    }
  }

  const transformApproveFlow = (flowArray) => {
    if (!Array.isArray(flowArray) || flowArray.length === 0) return null;
    // ดึงค่า evaluate_salary_id, budget_year, round จากตัวแรก
    const {
      evaluate_salary_id,
      budget_year,
      round
    } = flowArray[0];

    // แปลงเฉพาะรายการ approve_array
    const approve_array = flowArray
      .filter(item => item.approve_user)   // มี approve_user เท่านั้น
      .map((item, index) => ({
        approve_user_id: item.approve_user_id || null,
        approve_user: item.approve_user || "",
        approve_user_position_name: item.approve_user_position_name || "",
        cont_to: item.cont_to || "",
        step: index + 1   // ไล่ step ใหม่
      }));

    return {
      evaluate_salary_id: Number(evaluate_salary_id),
      budget_year: Number(budget_year),
      round: Number(round),
      approve_array
    };
  };

  const resetFlow = () => {
    fetchApproveUserFlow()
  }


  return (
    <Container fluid>
      <Row>
        <Col lg={6}>
          <Card>
            <CardBody>
              <Row>
                <Col className="text-end" xs={4} md={2} lg={3}>
                  <strong style={{ whiteSpace: "nowrap" }}>ผู้รับการประเมิน :</strong>
                </Col>
                <Col xs={8} md={10} lg={9}>
                  <strong>{dataInfo.user_name}</strong>
                </Col>
              </Row>
              <Row>
                <Col className="text-end" xs={4} md={2} lg={3}>
                  <strong> ตำแหน่ง :</strong>
                </Col>
                <Col xs={8} md={10} lg={9}>
                  <strong>{dataInfo.user_position_name}</strong>
                </Col>
              </Row>
              <Row>
                <Col className="text-end" xs={4} md={2} lg={3}>
                  <strong> สังกัด :</strong>
                </Col>
                <Col xs={8} md={10} lg={9}>
                  <strong>
                    {dataInfo.cont_to !== undefined ? (
                      <>{dataInfo.cont_to[0]?.org_name}</>
                    ) : (
                      ""
                    )}
                  </strong>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
        <Col lg={6}>
          <Card>
            {Number(budget_year) < 2569 ? (<CardBody>
              <Row>
                <Col className="text-end" xs={4} md={2} lg={3}>
                  <strong> ผู้ประเมิน :</strong>
                </Col>
                <Col xs={8} md={10} lg={9}>
                  {/* {console.log(updateApprove)} */}
                  {/* {updateApprove} */}
                  {/* {updateApprove !== null && updateApprove !== undefined ? (
                    <strong>{updateApprove.approve_user}</strong>
                  ) : ( */}
                  <strong>{approveInfo.user_name}</strong>
                  {/* // )} */}
                </Col>
              </Row>
              <Row>
                <Col className="text-end" xs={4} md={2} lg={3}>
                  <strong> ตำแหน่ง :</strong>
                </Col>
                <Col xs={8} md={10} lg={9}>
                  {/* {updateApprove !== null && updateApprove !== undefined ? (
                    <strong>{updateApproveUser.user_position_name}</strong>
                  ) : ( */}
                  <strong>{approveInfo.user_position_name}</strong>
                  {/* )} */}
                </Col>
              </Row>
              <Row>
                <Col className="text-end" xs={4} md={2} lg={3}>
                  <strong> สังกัด :</strong>
                </Col>
                <Col xs={8} md={10} lg={9}>
                  {/* {updateApprove !== null && updateApprove !== undefined ? (
                    <strong>
                      {updateApproveUser.cont_to !== undefined ? (
                        <>{updateApproveUser.cont_to[0]?.org_name}</>
                      ) : (
                        ""
                      )}
                    </strong>
                  ) : ( */}
                  <strong>
                    {approveInfo.cont_to !== undefined ? (
                      <>{approveInfo.cont_to[0]?.org_name}</>
                    ) : (
                      ""
                    )}
                  </strong>
                  {/* )} */}
                </Col>
              </Row>
            </CardBody>) : (<CardBody>
              {flowLoading ? <LoadingData /> : (<Row>{approveUserFlow?.map((x, i) => {
                const disabled = evaluateSalaryApprove.find((e) => e?.approve_user_id === x?.approve_user_id) || x.assessor //disable เมื่อถูกส่งไปแล้ว || เป็น assessor
                // const myEvaluate = user_id === userInfo?.user_id

                if ((CheckSubAdmin(userInfo?.positionSubAdmin).length > 0)
                  && ((CheckSubAdmin(userInfo?.positionSubAdmin).includes(0) || CheckSubAdmin(userInfo?.positionSubAdmin).includes(3)))) {
                  return (
                    <Row>
                      <Col md={10}>
                        <Row>
                          <Col className="text-end" xs={4} md={2} lg={3}>
                            <strong> ผู้ประเมิน :</strong>
                          </Col>
                          <Col xs={8} md={10} lg={9}>
                            <Row>
                              <Col md={10}>
                                <UserSelector disabled={disabled} className={"mb-2"} value={{ value: x, label: x.approve_user }} onChange={(value) => handleChangeUser(i, value)} />
                              </Col>
                              <Col md={2}>
                                {!disabled && <Button color="danger" onClick={() => { handleRemoveUserFlow(i) }}><i className="fa-solid fa-xmark" /></Button>}
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        {x.approve_user_position_name && (<Row>
                          <Col className="text-end" xs={4} md={2} lg={3}>
                            <strong> ตำแหน่ง :</strong>
                          </Col>
                          <Col xs={8} md={10} lg={9}>
                            <strong>{x.approve_user_position_name}</strong>
                          </Col>
                        </Row>)}
                        {x.cont_to && (<Row>
                          <Col className="text-end" xs={4} md={2} lg={3}>
                            <strong> สังกัด :</strong>
                          </Col>
                          <Col xs={8} md={10} lg={9}>
                            <strong>{x.cont_to}</strong>
                          </Col>
                        </Row>)}
                      </Col>
                      <Row className="text-center mt-2">
                        {!(i === approveUserFlow.length - 1) ? (
                          <Col md={12}>
                            <i className="fa-solid fa-caret-down fa-2x text-center m-2" />
                          </Col>
                        ) : (
                          <Row>
                            <Col
                              md={12}
                              className="d-flex justify-content-center gap-2 mt-2"
                            >
                              <Button color="primary" className="w-25" onClick={handleAddUserFlow}>
                                <i className="fa-solid fa-plus" /> เพิ่ม
                              </Button>

                              <Button color="success" className="w-25" onClick={handleEditFlow}>
                                <i className="fa-solid fa-save" /> บันทึก
                              </Button>

                              <Button color="secondary" className="w-25" onClick={resetFlow}>
                                <i className="fa-solid fa-history" /> รีเซ็ต
                              </Button>
                            </Col>
                          </Row>
                        )}
                      </Row>
                    </Row>)
                }
                return (
                  <Row>
                    <Col md={10}>
                      <Row>
                        <Col className="text-end" xs={4} md={2} lg={3}>
                          <strong> ผู้ประเมิน :</strong>
                        </Col>
                        <Col xs={8} md={10} lg={9}>
                          <Row>
                            <Col>
                              <strong>{x.approve_user}</strong>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      {x.approve_user_position_name && (<Row>
                        <Col className="text-end" xs={4} md={2} lg={3}>
                          <strong> ตำแหน่ง :</strong>
                        </Col>
                        <Col xs={8} md={10} lg={9}>
                          <strong>{x.approve_user_position_name}</strong>
                        </Col>
                      </Row>)}
                      {x.cont_to && (<Row>
                        <Col className="text-end" xs={4} md={2} lg={3}>
                          <strong> สังกัด :</strong>
                        </Col>
                        <Col xs={8} md={10} lg={9}>
                          <strong>{x.cont_to}</strong>
                        </Col>
                      </Row>)}
                    </Col>
                    <Row className="text-center mt-2">
                      {!(i === approveUserFlow.length - 1) ? (
                        <Col md={12}>
                          <i className="fa-solid fa-caret-down fa-2x text-center m-2" />
                        </Col>
                      ) : null}
                    </Row>
                  </Row>)
              })}
                <Col md={12} className="text-center mt-3">
                  <span className="text-danger">
                    ***หากลำดับขั้นการประเมินของท่านไม่ถูกต้อง ท่านสามารถดำเนินการแก้ไขเองได้ หรือติดต่อกลุ่ม IT
                  </span>
                </Col>
                <Col md={12} className="text-center">
                  <span className="text-danger">
                    แต่หากลำดับขั้นการประเมินของท่านถูกต้องแล้ว ให้ดำเนินการกรอกข้อมูลตัวชี้วัดผลงานได้ทันที
                  </span>
                </Col>
              </Row>)}
            </CardBody>)}
          </Card>
        </Col>
      </Row>
      <Row>
        <Col lg="12">
          <Card>
            <CardBody>
              <div className="wizard clearfix">
                {loading ?
                  <LoadingData />
                  : <Fragment>
                    <div className="steps clearfix">
                      <ul>
                        <NavItem className={classnames({ current: activeTab === 1 })}>
                          <NavLink style={{ border: activeTab === 1 ? "2px solid #0d6efd" : "" }} className={`${classnames({ current: activeTab === 1 })} h-100`} onClick={() => { setactiveTab(1) }} disabled={!(passedSteps || []).includes(1)}>
                            <Row className="mb-2">
                              <Col lg={2}>
                                <span className="number">1.</span>
                              </Col>
                              <Col lg={10}>แบบประเมินผลสัมฤทธิ์ของงาน</Col>
                            </Row>

                            <Row>
                              <Col lg={2}></Col>
                              <Col lg={10}>
                                <Col>
                                  คะแนนรวม :{" "}
                                  <Badge color="info" className="ms-2">
                                    <h4 className="m-0">
                                      {calculatedValues.length !== 0
                                        ? `${(calculatedValues * (100 / 5)).toFixed(4)}`
                                        : "0.00"}
                                    </h4>
                                  </Badge>
                                </Col>
                              </Col>
                            </Row>
                          </NavLink>
                        </NavItem>
                        <NavItem className={classnames({ current: activeTab === 2 })}>
                          <NavLink style={{ backgroundColor: "rgba(161,238,189,0.5)", border: activeTab === 2 ? "2px solid #1EB053" : "" }} className={`${classnames({ active: activeTab === 2 })} h-100`} onClick={() => { setactiveTab(2) }} disabled={!(passedSteps || []).includes(2)}>
                            <Row className="mb-2">
                              <Col lg={2}>
                                <span className="number2">2.</span>
                              </Col>
                              <Col lg={10}>
                                แบบประเมินพฤติกรรมการปฏิบัติราชการหรือสมรรถนะ
                              </Col>
                            </Row>
                            <Row>
                              <Col lg={2}></Col>
                              <Col lg={10}>
                                <Col>
                                  คะแนนรวม :{" "}
                                  <Badge color="info" className="ms-2">
                                    <h4 className="m-0">
                                      {calculatedValuesForm2.length !== 0
                                        ? `${(calculatedValuesForm2 * (100 / 5)).toFixed(
                                          4
                                        )}`
                                        : "0.00"}
                                    </h4>
                                  </Badge>
                                </Col>
                              </Col>
                            </Row>
                          </NavLink>
                        </NavItem>
                        <NavItem className={classnames({ current: activeTab === 3 })}>
                          <NavLink style={{ backgroundColor: "rgba(255,190,125,0.5)", border: activeTab === 3 ? "2px solid #EA7603" : "" }} className={`${classnames({ active: activeTab === 3 })} h-100`} onClick={() => { setactiveTab(3) }} disabled={!(passedSteps || []).includes(3)}>
                            <Row className="mb-2">
                              <Col lg={2}>
                                <span className="number3">3.</span>
                              </Col>
                              <Col lg={10}>แบบสรุปการประเมินผลการปฏิบัติราชการ</Col>
                            </Row>
                            <Row>
                              <Col lg={2}></Col>
                              <Col lg={10}>
                                <Col lg={12} className="mb-2">
                                  คะแนนรวม :{" "}
                                  <Badge color="info" className="ms-2">
                                    <h4 className="m-0">
                                      {formTheeData_1.score !== "" &&
                                        formTheeData_2.score !== ""
                                        ? valScore.toFixed(4)
                                        : "0.00"}
                                    </h4>
                                  </Badge>
                                </Col>
                                <Col lg={12} className="d-flex justify-content-end">
                                  <Badge color="primary">
                                    {valScore > 0 && <strong className="p-2" style={{ fontSize: "1.3rem" }}>{checkEvaluateScoreLevel(valScore)}</strong>}
                                    {/* {valScore >= 90 && valScore <= 100 ? (
                                      <strong className="ps-2" style={{ fontSize: "1.3rem" }}>ดีเด่น</strong>
                                    ) : (
                                      ""
                                    )}
                                    {valScore >= 80 && valScore <= 89 ? (
                                      <strong className="ps-2" style={{ fontSize: "1.3rem" }}>ดีมาก</strong>
                                    ) : (
                                      ""
                                    )}
                                    {valScore >= 70 && valScore <= 79 ? (
                                      <strong className="ps-2" style={{ fontSize: "1.3rem" }}>ดี</strong>
                                    ) : (
                                      ""
                                    )}
                                    {valScore >= 60 && valScore <= 69 ? (
                                      <strong className="ps-2" style={{ fontSize: "1.3rem" }}>พอใช้</strong>
                                    ) : (
                                      ""
                                    )}
                                    {valScore < 60 ? (
                                      <strong className="ps-2" style={{ fontSize: "1.3rem" }}>ต้องปรับปรุง</strong>
                                    ) : (
                                      ""
                                    )} */}
                                  </Badge>
                                </Col>
                              </Col>
                            </Row>
                          </NavLink>
                        </NavItem>
                        <NavItem className={classnames({ current: activeTab === 4 })}>
                          <NavLink style={{ backgroundColor: "rgba(246,214,214,0.5)", border: activeTab === 4 ? "2px solid #F54B4B" : "" }} className={`${classnames({ active: activeTab === 4 })} h-100`} onClick={() => { setactiveTab(4) }} disabled={!(passedSteps || []).includes(4)}>
                            <Row className="mb-2">
                              <Col lg={2}>
                                <span className="number4">4.</span>
                              </Col>
                              <Col lg={10}>แผนพัฒนาการปฏิบัติราชการรายบุคคล</Col>
                            </Row>
                            <Row>
                              <Col lg={2}></Col>
                              <Col lg={10}>
                                <div style={{ paddingBottom: "7px" }} />
                                <strong className="fs-5">เรียงลำดับจากมากไปน้อย</strong>
                              </Col>
                            </Row>
                          </NavLink>
                        </NavItem>
                      </ul>
                    </div>
                    <div>
                      <TabContent activeTab={activeTab} className="body">
                        <TabPane tabId={1}>
                          <Table bordered responsive>
                            <EvaluateFormHeader mode="VIEW" />
                            <tbody>
                              {evaluateData !== null && evaluateData.length !== 0
                                && evaluateData
                                  ?.sort((a, b) => a.no - b.no)
                                  ?.map((group, groupIndex) => (
                                    <tr key={groupIndex}>
                                      <td className="text-center">{groupIndex + 1}</td>
                                      <td style={{ width: "250px" }}>
                                        <Input
                                          disabled
                                          style={{ height: "100px" }}
                                          type="textarea"
                                          name={`indicator_${groupIndex}`}
                                          value={group.indicator}
                                        />
                                      </td>

                                      <td
                                        style={{ width: "100px" }}
                                        className="text-center"
                                      >
                                        <Input
                                          disabled
                                          className="text-center px-0"
                                          type="text"
                                          value={group.score_1}
                                        />
                                      </td>
                                      <td
                                        style={{ width: "100px" }}
                                        className="text-center"
                                      >
                                        <Input
                                          disabled
                                          className="text-center px-0"
                                          type="text"
                                          value={group.score_2}
                                        />
                                      </td>
                                      <td
                                        style={{ width: "100px" }}
                                        className="text-center"
                                      >
                                        <Input
                                          disabled
                                          className="text-center px-0"
                                          type="text"
                                          value={group.score_3}
                                        />
                                      </td>
                                      <td
                                        style={{ width: "100px" }}
                                        className="text-center"
                                      >
                                        <Input
                                          disabled
                                          className="text-center px-0"
                                          type="text"
                                          value={group.score_4}
                                        />
                                      </td>
                                      <td
                                        style={{ width: "100px" }}
                                        className="text-center"
                                      >
                                        <Input
                                          disabled
                                          className="text-center px-0"
                                          type="text"
                                          value={group.score_5}
                                        />
                                      </td>
                                      <td
                                        style={{ width: "100px" }}
                                        className="text-center"
                                        name={`score_${groupIndex}`}
                                      >
                                        <Input
                                          disabled
                                          className="text-center"
                                          type="text"
                                          value={group.score && Number(group.score).toFixed(2)}
                                        />
                                      </td>
                                      <td
                                        style={{ width: "100px" }}
                                        className="text-center"
                                        name={`weight_${groupIndex}`}
                                      >
                                        <Input
                                          disabled
                                          className="text-center"
                                          type="text"
                                          value={group.weight}
                                        />
                                      </td>
                                      <td className="text-center pb-2">
                                        {group.weight &&
                                          group.score && (
                                            <strong>
                                              {(
                                                (group.weight * group.score) /
                                                100
                                              ).toFixed(4)}
                                            </strong>
                                          )}
                                      </td>
                                      <td className="text-center">
                                        <Row className="justify-content-center text-center">
                                          <Col xs="auto">
                                          {
                                            (group.file_data ? (() => {
                                                  const link = group.file_data.replace("public/", "");
                                                  const filename = group.file_data.replace("./public/evaluate_salary/file/", "");
                                                  const fileExt = group.file_data.split(".").pop();
                                                  const isPdf = fileExt === "pdf";
                                                  const isDoc = fileExt === "doc" || fileExt === "docx";
                                                  const iconName = fileExt === "docx" ? "doc" : fileExt;
                                                  const colorClass = isPdf ? "danger" : isDoc ? "info" : "secondary";
                                                                                                  
                                                  const dotIndex = filename.lastIndexOf(".");
                                                  const nameOnly = dotIndex !== -1 ? filename.slice(0, dotIndex) : filename;
                                                  const extOnly = dotIndex !== -1 ? filename.slice(dotIndex) : "";
                                      
                                                  return (
                                                    <a
                                                      href={`${API_URL}/${link}`}
                                                      target="_blank"
                                                      rel="noreferrer"
                                                      className={`d-flex align-items-center gap-2 px-2 py-1 rounded text-decoration-none text-${colorClass}`}
                                                    >
                                                      <i className={`fa-solid fa-file-${iconName}`} style={{ fontSize: 32 }} />
                                                      {/* <span
                                                        className="small d-inline-flex"
                                                        style={{ maxWidth: 140, overflow: "hidden" }}
                                                      >
                                                        <span className="text-truncate">{nameOnly}</span>
                                                        <span className="flex-shrink-0">{extOnly}</span>
                                                      </span> */}
                                                    </a>
                                                  );
                                                })() : <span className="text-muted">ไม่มีไฟล์</span>)
                                          }
                                          </Col>
                                        </Row>
                                      </td>
                                    </tr>
                                  ))
                              }
                            </tbody>
                          </Table>
                          <InputGroup className="my-2">
                            <Input disabled placeholder="link เอกสารเพิ่มเติม" value={evaluateLink === undefined || evaluateLink === null ? null : evaluateLink} />
                            <Button color="primary">
                              <Link target="_blank" to={evaluateLink} style={{ color: "#ffffff" }}>
                                <i className="fa-solid fa-earth-americas"></i>
                              </Link>
                            </Button>
                          </InputGroup>
                        </TabPane>
                        <TabPane tabId={2}>
                          <Table bordered responsive>
                            <thead
                              className="table-light"
                              style={{ whiteSpace: "nowrap" }}
                            >
                              <tr>
                                <th className="text-center">สมรรถนะ</th>
                                <th>ระดับที่คาดหวัง</th>

                                <th className="text-center">
                                  คะแนน
                                  <br />
                                  (ก)
                                </th>
                                <th rowSpan="2" className="text-center">
                                  น้ำหนัก
                                  <br />
                                  ร้อยละ
                                  <br />
                                  (ข)
                                </th>
                                <th rowSpan="2" className="text-center">
                                  คะแนนรวม
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {/* {console.log(9999,formTwoData)
                            } */}
                              {formTwoData.map((item, index) => (
                                <tr key={item.id + index}>
                                  <td>{item.label}</td>
                                  <td  //ระดับที่คาดหวัง  
                                    className="text-center"
                                    style={{ width: "150px" }}
                                  >
                                    {checkExpectLevel(dataInfo.user_level_id)}
                                  </td>
                                  <td //คะแนน
                                    style={{ width: "100px" }}>
                                    {/* <Input
                                      className="text-center"
                                      type="text"
                                      value={item.score}
                                      disabled
                                    /> */}
                                    {item.score !== "" ? (
                                      <>
                                        {Number(item.score).toFixed(2)}
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </td>
                                  <td // น้ำหนัก
                                    className="text-center"
                                    style={{ width: "150px" }}
                                  >
                                    ร้อยละ {item.percentage}
                                  </td>
                                  <td
                                    className="text-center"
                                    style={{ width: "150px" }}
                                  >
                                    {item.score !== "" ? (
                                      <>
                                        {(
                                          (item.score * item.percentage) /
                                          100
                                        ).toFixed(4)}
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </TabPane>
                        <TabPane tabId={3}>
                          <Table bordered responsive>
                            <thead
                              className="table-light"
                              style={{ whiteSpace: "nowrap" }}
                            >
                              <tr>
                                <th className="text-center">
                                  องค์ประกอบการประเมิน
                                </th>

                                <th className="text-center">
                                  คะแนน
                                  <br />
                                  (ก)
                                </th>
                                <th rowSpan="2" className="text-center">
                                  สัดส่วนคะแนน
                                  <br />
                                  (น้ำหนัก) (ข)
                                </th>
                                <th rowSpan="2" className="text-center">
                                  รวมคะแนน
                                  <br />
                                  (ก)x(ข)
                                </th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr>
                                <td>{formTheeData_1.label}</td>
                                <td
                                  className="text-center"
                                  style={{ width: "150px" }}
                                >
                                  {formTheeData_1.score}
                                </td>
                                <td
                                  className="text-center"
                                  style={{ width: "150px" }}
                                >
                                  {formTheeData_1.percentage}%
                                </td>

                                <td
                                  className="text-center"
                                  style={{ width: "150px" }}
                                >
                                  {formTheeData_1.score !== "" ? (
                                    <>
                                      {(
                                        (formTheeData_1.score *
                                          formTheeData_1.percentage) /
                                        100
                                      ).toFixed(4)}
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td>{formTheeData_2.label}</td>
                                <td
                                  className="text-center"
                                  style={{ width: "150px" }}
                                >
                                  {formTheeData_2.score}
                                </td>
                                <td
                                  className="text-center"
                                  style={{ width: "150px" }}
                                >
                                  {formTheeData_2.percentage}%
                                </td>

                                <td
                                  className="text-center"
                                  style={{ width: "150px" }}
                                >
                                  {formTheeData_2.score !== "" ? (
                                    <>
                                      {(
                                        (formTheeData_2.score *
                                          formTheeData_2.percentage) /
                                        100
                                      ).toFixed(4)}
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </TabPane>
                        <TabPane tabId={4}>
                          <Table bordered responsive>
                            <thead
                              className="table-light"
                              style={{ whiteSpace: "nowrap" }}
                            >
                              <tr>
                                <th className="text-center">ลำดับ</th>
                                <th className="text-center">หัวข้อการพัฒนา</th>

                                <th colSpan={7} className="text-center">
                                  การพัฒนาตนเอง
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {evaluateDataDevelopment.length !== 0 &&
                                evaluateDataDevelopment !== null
                                ? evaluateDataDevelopment
                                  .slice()
                                  .sort((a, b) => a.no - b.no)
                                  .map((item, index) => {
                                    return (
                                      <tr key={index}>
                                        <td
                                          className="text-center"
                                          style={{ width: "60px" }}
                                        >
                                          {item.no}
                                        </td>
                                        <td>
                                          <Input
                                            disabled
                                            value={item.development_type_id}
                                            type="select"
                                          >
                                            <option>เลือกหัวข้อการพัฒนา</option>
                                            <option value="1">
                                              ด้านการมุ่งผลสัมฤทธิ์
                                            </option>
                                            <option value="2">
                                              ด้านการบริการที่ดี
                                            </option>
                                            <option value="3">
                                              ด้านการสั่งสมความเชี่ยวชาญในอาชีพ
                                            </option>
                                            <option value="4">
                                              ด้านการยึดมั่นในความถูกต้องชอบธรรมและจริยธรรม
                                            </option>
                                            <option value="5">
                                              ด้านการทำงานเป็นทีม
                                            </option>
                                            <option value="6">
                                              ด้านเทคโนโลยีสารสนเทศ
                                            </option>
                                            <option value="7">ด้านภาษา</option>
                                            <option value="8">
                                              ด้านการบริหารจัดการ
                                            </option>
                                            <option value="9">
                                              ด้านการวิเคราะห์ การจัดทำข้อมูล
                                            </option>
                                            <option value="10">
                                              ด้านการพัฒนานวัตกรรม
                                            </option>
                                            <option value="11">
                                              ด้านการสื่อสาร
                                            </option>
                                            <option value="12">อื่นๆ</option>
                                          </Input>
                                        </td>
                                        <td
                                          className="text-center"
                                          style={{ width: "700px" }}
                                        >
                                          <Input
                                            disabled
                                            style={{ height: "100px" }}
                                            type="textarea"
                                            placeholder="ระบุหลักสูตร/วิธีการ/แนวทางที่ต้องการ"
                                            value={item.development}
                                            onChange={e =>
                                              handleDevelopmentChange(
                                                item.id,
                                                "description",
                                                e.target.value
                                              )
                                            }
                                          />
                                        </td>
                                      </tr>
                                    );
                                  })
                                : formFourData.map(item => (
                                  <tr key={item.id}>
                                    <td
                                      className="text-center"
                                      style={{ width: "60px" }}
                                    >
                                      {item.id}
                                    </td>
                                    <td>
                                      <Input
                                        disabled
                                        type="select"
                                        onChange={e =>
                                          handleDevelopmentChange(
                                            item.id,
                                            "topic",
                                            e.target.value
                                          )
                                        }
                                      >
                                        <option>เลือกหัวข้อการพัฒนา</option>
                                        <option value="1">
                                          ด้านการมุ่งผลสัมฤทธิ์
                                        </option>
                                        <option value="2">
                                          ด้านการบริการที่ดี
                                        </option>
                                        <option value="3">
                                          ด้านการสั่งสมความเชี่ยวชาญในอาชีพ
                                        </option>
                                        <option value="4">
                                          ด้านการยึดมั่นในความถูกต้องชอบธรรมและจริยธรรม
                                        </option>
                                        <option value="5">
                                          ด้านการทำงานเป็นทีม
                                        </option>
                                        <option value="6">
                                          ด้านเทคโนโลยีสารสนเทศ
                                        </option>
                                        <option value="7">ด้านภาษา</option>
                                        <option value="8">
                                          ด้านการบริหารจัดการ
                                        </option>
                                        <option value="9">
                                          ด้านการวิเคราะห์ การจัดทำข้อมูล
                                        </option>
                                        <option value="10">
                                          ด้านการพัฒนานวัตกรรม
                                        </option>
                                        <option value="11">ด้านการสื่อสาร</option>
                                        <option value="12">อื่นๆ</option>
                                      </Input>
                                    </td>
                                    <td
                                      className="text-center"
                                      style={{ width: "700px" }}
                                    >
                                      <Input
                                        disabled
                                        style={{ height: "100px" }}
                                        type="textarea"
                                        placeholder="ระบุหลักสูตร/วิธีการ/แนวทางที่ต้องการ"
                                        value={item.description}
                                        onChange={e =>
                                          handleDevelopmentChange(
                                            item.id,
                                            "description",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </Table>
                        </TabPane>
                      </TabContent>
                    </div>
                    <div className="actions clearfix ms-2">
                      <ul>
                        <li style={{ cursor: activeTab === 1 ? "not-allowed" : "" }} className={`${activeTab === 1 ? "previous disabled" : "previous"} mt-2`}>
                          <Button disabled={activeTab === 1} color="primary" onClick={() => { toggleTab(activeTab - 1) }}>
                            ย้อนกลับ
                          </Button>
                        </li>
                        <li style={{ cursor: activeTab === 4 ? "not-allowed" : "" }} className={`${activeTab === 4 ? "next disabled" : "next"} mt-2`}>
                          <Button disabled={activeTab === 4} color="primary" onClick={() => { toggleTab(activeTab + 1) }}>
                            ถัดไป
                          </Button>
                        </li>
                      </ul>
                    </div>
                  </Fragment>}
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default ViewEvaluate;
